import {
	MimaButton,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Settings/Settings.module.scss';
import { MdModeEditOutline } from 'react-icons/md';
import { BsSave } from 'react-icons/bs';
import { Formik } from 'formik';
import React from 'react';

const BusinessInfo = ({
	closeModal,
	editState,
	goToEditState,
	business,
	validationSchema,
	loading,
	onSubmit,
	file,
	selectClick,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<div className={styles.bus}>
				<div className={styles.bus__head}>
					<MimaText variant="subtitleBold">Business Information</MimaText>
					{!editState && (
						<div className={styles.bus__edit} onClick={goToEditState}>
							<MdModeEditOutline />
							<MimaText variant="small" color="var(--color-primary)">
								Edit
							</MimaText>
						</div>
					)}
					{editState && (
						<div className={styles.bus__edit} onClick={goToEditState}>
							<BsSave />
							<MimaText variant="small" color="var(--color-primary)">
								Save
							</MimaText>
						</div>
					)}
				</div>

				<div className={styles.bus__details}>
					<div className={styles.bus__img}>
						<img
							src={business?.logoUrl}
							alt="logo"
							className={styles.bus__logo}
						/>
					</div>

					<MimaText labelTitle="Business Owner">
						{' '}
						{`${business?.users?.[0].firstname || ''} ${business?.users?.[0].lastname || ''}`}
					</MimaText>
					<MimaText labelTitle="Phone Number">{business?.mobile}</MimaText>
					<MimaText labelTitle="Email"> {business?.email}</MimaText>
					{!editState && (
						<div className={styles.bus__details}>
							<MimaText labelTitle="Business Name">
								{' '}
								{business?.tradingName}
							</MimaText>
							<MimaText labelTitle="Address">
								{business?.businessAddress}
							</MimaText>
							<MimaText labelTitle="Business Registration Number">
								{business?.businessRegNum}
							</MimaText>
							<MimaText labelTitle="Website Address">
								{' '}
								{business?.website}
							</MimaText>
							<MimaText labelTitle="Instagram Handle">
								{business?.instagramHandle}
							</MimaText>
							<MimaText labelTitle="Twitter Handle">
								{business?.twitterHandle}
							</MimaText>
						</div>
					)}
					{editState && (
						<div className={styles.bus__details}>
							<Formik
								initialValues={{
									businessName: business?.tradingName,
									address: business?.businessAddress
										? business?.businessAddress
										: '',
									regNumber: business?.businessRegNum
										? business?.businessRegNum
										: '',
									webAddress: business?.website ? business?.website : '',
									instagram: business?.instagramHandle
										? business?.instagramHandle
										: '',
									twitter: business?.twitterHandle
										? business?.twitterHandle
										: '',
								}}
								validationSchema={validationSchema}
								onSubmit={onSubmit}>
								{({ handleChange, handleBlur, handleSubmit, values }) => (
									<>
										<MimaButton
											title="Select Logo"
											variant="outlined"
											width={38}
											onClick={selectClick}
										/>
										<MimaText
											variant="small"
											mt={2}
											width={38}
											align="center"
											color="var(--color-primary)">
											{file?.name || ''}{' '}
										</MimaText>
										<MimaTextArea
											type="text"
											labelTitle="Address"
											name="address"
											variant="wide"
											value={values.address}
											onChange={handleChange}
											onBlur={handleBlur}
											width={38}
											height={10}
										/>
										<MimaInput
											type="text"
											labelTitle="Website"
											name="webAddress"
											value={values.webAddress}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<MimaInput
											type="text"
											labelTitle="Instagram Handle"
											name="instagram"
											value={values.instagram}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<MimaInput
											type="text"
											labelTitle="Twitter Handle"
											name="twitter"
											value={values.twitter}
											onChange={handleChange}
											onBlur={handleBlur}
										/>

										<MimaButton
											title="Continue"
											loading={loading}
											type="submit"
											onClick={handleSubmit}
										/>
									</>
								)}
							</Formik>
						</div>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default BusinessInfo;
